import { createPinia, setActivePinia } from 'pinia';
import { createPersistedState } from 'pinia-plugin-persistedstate'; // 数据持久化

const store = createPinia();
store.use(
  createPersistedState({
    storage: {
      // 包一层 try/catch：iOS 阻止 Cookie/无痕模式下 localStorage 不可用时，避免 store 初始化崩溃导致白屏
      getItem: (key: string) => {
        try {
          return uni.getStorageSync(key);
        }
        catch (e) {
          console.error('[pinia-persist] getItem error:', e);
          return null;
        }
      },
      setItem: (key: string, value: string) => {
        try {
          uni.setStorageSync(key, value);
        }
        catch (e) {
          console.error('[pinia-persist] setItem error:', e);
        }
      },
    },
  }),
);
// 立即激活 Pinia 实例, 这样即使在 app.use(store)之前调用 store 也能正常工作 （解决APP端白屏问题）
setActivePinia(store);

export default store;

// 足迹历史
export * from './common/history-goods';
// app相关内容
export * from './common/notice';
// 档口独立站项目档口数据
export * from './common/seller-site';
export { useSiteStore } from './common/site';
export * from './common/site';
export * from './modules/app';
// 注意：dialogues store 仅 pages-chat 分包使用，不在此统一导出（
// 统一导出会被 main.ts 拖入小程序主包，浪费主包体积）；
// pages-chat 内部请直接 import '@/store/modules/dialogues'
// 推送相关
export * from './modules/push';
export * from './modules/socket';
// 档口列表缓存
export * from './modules/stall-list';
// 主题相关
export * from './modules/theme';
export * from './modules/ticketActive';
// 模块统一导出
export * from './modules/token';

export * from './modules/user';
export * from './modules/wallet';
export * from './photo-space/file-list';
export * from './photo-space/folder-list';
export * from './seller/activity-list';
export * from './seller/deposit';
export * from './seller/fans';
export * from './seller/home';
export * from './seller/info';
export * from './seller/pay';
export * from './seller/point-list';
export * from './seller/point-purchase';
export * from './seller/product-list';
export * from './seller/sn-list';
export * from './seller/standby-statisticians';
export * from './seller/upload-record';
